'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isType = function isType(type, value) {
  return Object.prototype.toString.call(value).toLowerCase().replace('[object', '').includes(type);
};

exports.isType = isType;
//# sourceMappingURL=isType.js.map
